import type { DailyTacticalReadiness } from '../../services/operationsApi';
import { cohortLabel } from './fableLabels';

const SOURCE_LABEL: Record<string, string> = {
  UNIVERSE: '종목 목록',
  MARKET: '시세',
  PROMPT: '질문 원문',
  NEWS: '뉴스',
  PREMARKET: '개장 전 시세',
};

function sourceText(types: string[]): string {
  if (types.length === 0) return '없음';
  return types.map((t) => `${SOURCE_LABEL[t] || t}(${t})`).join(', ');
}

/** 판단 근거가 빠짐없이 저장됐는지 기록별로 보여주는 패널. */
export default function FableEvidence({ readiness }: Props) {
  const rows = readiness.evidence_completeness || [];
  return (
    <section className="fable-panel">
      <header className="fable-panel-head">
        <h3>판단 근거가 다 저장됐나</h3>
        <p>
          근거 묶음(evidence snapshot)은 나중에 판단을 재검증하기 위한 저장물입니다.
          필수: 종목 목록·시세·질문 원문, 그리고 뉴스 또는 개장 전 시세 중 1개.
        </p>
      </header>
      {rows.length === 0 ? (
        <p className="fable-empty">아직 점검할 근거 묶음이 없습니다. (데이터 없음)</p>
      ) : (
        <ul className="fable-evidence-list">
          {rows.slice(0, 5).map((row) => {
            const plumbing = isPlumbing(row.cohort_id);
            const stateClass = row.complete ? 'ok' : plumbing ? 'expected-gap' : 'bad';
            return (
              <li key={row.run_id} className={`fable-evidence ${stateClass}`}>
                <div>
                  <strong>{row.trading_date}</strong>
                  <span className="fable-tag">{cohortLabel(row.cohort_id)}</span>
                  <code>{row.cohort_id}</code>
                </div>
                <span className="fable-evidence-state">{stateText(row.complete, plumbing)}</span>
                <p>
                  저장됨: {sourceText(row.source_types)}
                  {row.missing_required_source_types.length > 0 && (
                    <> · 누락: {sourceText(row.missing_required_source_types)}</>
                  )}
                  {!row.has_news_or_premarket && ' · 뉴스/개장 전 시세 근거 없음'}
                  {plumbing && !row.complete && ' · 배관 테스트 기록이라 공식 관찰 판정에는 쓰지 않습니다.'}
                </p>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

function isPlumbing(cohortId: string): boolean {
  return cohortId.includes('PLUMBING');
}

function stateText(complete: boolean, plumbing: boolean): string {
  if (complete) return '완성';
  if (plumbing) return '배관 테스트 누락';
  return '누락 있음';
}

type Props = { readiness: DailyTacticalReadiness };
